import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class UsersService {

  private _usersUrl = './api/users/';

  constructor(private _http: HttpClient) { }

  isAuthenicated(): Observable<boolean> {
    return this._http.get<boolean>(this._usersUrl + "IsAuthenicated");
  }
  

  hasManagerRoles(): Observable<boolean> {
    return this._http.get<boolean>(this._usersUrl + "HasManagerRoles");
  }

  private handleError(err: HttpErrorResponse) {
    console.log(err.message);
    return Observable.throw(err.message);
  }

}
